import React from 'react';
import { ModalContainer, ModalContent, CardContent, Table, TableContainer, Thead, Tbody, Tr, Th, Td, Button } from './StyledComponents';

const ArchivedAccountsModal = ({ isOpen, onClose, accounts, onRestore }) => {
  if (!isOpen) return null;

  const handleRestoreClick = (event, accountId) => {
    event.stopPropagation();
    onRestore(accountId);
  };

  const sortedAccounts = [...accounts].sort(([, a], [, b]) => {
    const typeCompare = (a.type || '').localeCompare(b.type || '', undefined, { sensitivity: 'base', numeric: true });
    if (typeCompare !== 0) return typeCompare;
    return (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base', numeric: true });
  });

  return (
    <ModalContainer onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <h2>Archived Accounts</h2>
        <CardContent>
          {sortedAccounts.length === 0 ? (
            <p>No archived accounts available.</p>
          ) : (
            <TableContainer>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Name</Th>
                    <Th>Type</Th>
                    <Th>Actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {sortedAccounts.map(([id, account]) => (
                    <Tr key={id}>
                      <Td>{account.name}</Td>
                      <Td>{account.type}</Td>
                      <Td>
                        <Button onClick={(e) => handleRestoreClick(e, id)}>Restore</Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
        <Button onClick={onClose}>Close</Button>
      </ModalContent>
    </ModalContainer>
  );
};

export default ArchivedAccountsModal;
